import { render } from "./SidebarComponent.vue?vue&type=template&id=fb068f86&ts=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=ts"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts"

import "./SidebarComponent.vue?vue&type=style&index=0&id=fb068f86&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__